<div class="modal active">
  <div class="modal__container modal__container--sm" style="max-width: 600px">
    <div class="fields">
      <h2>Send NOTAM</h2>
      <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form #form="ngForm" autocomplete="off"  class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="dropdown-fields">
                <div>
                  <label for="list">Select Mailing List</label>
                  <div>
                    <select id="list" [(ngModel)]="list" name="list" required>
                      <option *ngFor="let list of gritUserService.profile.mailingList" [value]="list.name">{{list.name}}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="title">
                <h4>Preview NOTAM</h4><span> </span>
              </div>
              <div style=" border: 1px solid; border-radius: 3px; padding: 5px">
                <p *ngFor="let phrase of notam?.generate().split('\n')" style="margin:0; font-weight: bolder">
                  {{phrase}}
                </p>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button class="blue" [ngClass]="form.form.valid ? 'blue' : 'gray'"
                    [disabled]="!form.form.valid" (click)="ok();">Send</button>
            <button class="gray" (click)="cancel()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
